import React, { FC, useState, useEffect, Fragment } from 'react';
import styled from 'styled-components';

import { FlexRowCentred, PageTitle } from '../common-styles/common-styles';
import { useFetchTeeTimeBookingData } from '../../api/hooks/use-fetch-tee-booking-players';
import { TeeBookingPlayer, UpdateStatus } from '../../../database.schema';
import { UpdateButton } from './update-button';
import { RouterLink } from '../../App';
import { HamburgerBar1, HamburgerBar2, HamburgerContainer } from '../navigation/navigation-styles';

const BookingWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  text-align: left;
  width: 100vw;
  height: 100vh;
  background: white;
  z-index: 9999999;
`;

const Table = styled.table`
  table-layout: auto;
  width: 100%;
  border-collapse: collapse;
  color: blue;
  background: transparent;
  font-size: 1.25rem;
  margin: 1.5rem 0.5rem;
`;

const TableHeader = styled.th`
  text-align: center;
  color: black;
  font-weight: bold;
  font-size: 1.35rem;
`;

const TableCell = styled.td`
  text-align: center;
  padding: 1rem 0 0;
`;

const CheckboxInput = styled.input`
  width: 1rem;
  height: 1rem;
`;

const MessageWrapper = styled.div`
  height: 2rem;
`;
const SuccessMessage = styled.div`
  margin: 1rem;
  font-size: 1rem;
  color: green;
`;
const ErrorMessage = styled.div`
  margin: 1rem;
  font-size: 1rem;
  color: red;
`;

export const TeeBookingPlayers: FC = () => {
  const [updateStatus, setUpdateStatus] = useState<UpdateStatus>({ success: false, error: false });
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [players, setPlayers] = useState<Array<TeeBookingPlayer>>([]);
  const [disabledMessage, setDisableMessage] = useState('');
  const { data, error, isLoading } = useFetchTeeTimeBookingData();

  useEffect(() => {
    const teeBookingPlayers = data as TeeBookingPlayer[];
    setPlayers(teeBookingPlayers);
  }, [setPlayers]);

  if (isLoading) {
    return <div>loading</div>;
  }
  if (error) {
    return <div>Error</div>;
  }

  const modifyUpdateStatus = (modifiedStatus: UpdateStatus) => {
    if (modifiedStatus.success) {
      setIsDisabled(true);
    }
    setUpdateStatus({ ...modifiedStatus });
  };

  const updatePlayerPlaying = (playerIndex: number) => {
    setUpdateStatus({ success: false, error: false });
    const playersCopy = [...players];
    const playerCopy = { ...playersCopy[playerIndex], playing: !playersCopy[playerIndex].playing };
    playersCopy.splice(playerIndex, 1, playerCopy);
    setPlayers(playersCopy);
    checkIfShouldBeDisabled(playersCopy);
  };

  const checkIfShouldBeDisabled = (playersUpdated: Array<TeeBookingPlayer>) => {
    const playersPlaying = playersUpdated.filter((player: TeeBookingPlayer) => player.playing);
    const playersPlayingWithLoginDetails = playersUpdated.filter((player: TeeBookingPlayer) => player.playing && player.hasLoginDetails);
    if (playersPlaying.length > 0 && playersPlaying.length / 4 > playersPlayingWithLoginDetails.length) {
      setDisableMessage('Not enough players with logins to make booking');
      return setIsDisabled(true);
    }
    setDisableMessage('');
    return setIsDisabled(false);
  };
  return (
    <BookingWrapper>
      <PageTitle style={{ padding: '1rem' }}>
        <h2>SBM Tee Booking Admin</h2>
        <RouterLink to={'/'}>
          <HamburgerContainer>
            <FlexRowCentred>
              <div>
                <HamburgerBar1 data-testid="bar1" style={{ transform: 'translate(2px, 8px) rotate(-45deg)', backgroundColor: 'black' }}></HamburgerBar1>
                <HamburgerBar2 data-testid="bar2" style={{ opacity: 0 }}></HamburgerBar2>
                <HamburgerBar1 data-testid="bar3" style={{ transform: 'translate(2px, -11px) rotate(45deg)', backgroundColor: 'black' }}></HamburgerBar1>
              </div>
            </FlexRowCentred>
          </HamburgerContainer>
        </RouterLink>
      </PageTitle>
      <Table data-testid="scorecard-handicap-table">
        <thead>
          <tr>
            <TableHeader>Player</TableHeader>
            <TableHeader>Playing</TableHeader>
            <TableHeader>Has Login</TableHeader>
            <TableHeader></TableHeader>
          </tr>
        </thead>
        <tbody>
          {players.map((player: TeeBookingPlayer, index: number) => (
            <tr key={`player-${player.pk}`}>
              <TableCell>{player.playerName}</TableCell>
              <TableCell>
                <CheckboxInput
                  type="checkbox"
                  name="playing"
                  id={`playing-${player.pk}`}
                  data-testid={`playing-${player.pk}`}
                  checked={player.playing === true}
                  onChange={() => updatePlayerPlaying(index)}
                />
              </TableCell>
              <TableCell>{player.hasLoginDetails ? 'yes' : 'no'}</TableCell>
            </tr>
          ))}
        </tbody>
      </Table>
      <MessageWrapper>
        <ErrorMessage>{disabledMessage}</ErrorMessage>
        {updateStatus.success && <SuccessMessage>Update Success!!!!</SuccessMessage>}
        {updateStatus.error && <ErrorMessage>Update failed!!!!</ErrorMessage>}
      </MessageWrapper>
      <UpdateButton playerData={players} isDisabled={isDisabled} setUpdateStatus={modifyUpdateStatus} />
    </BookingWrapper>
  );
};
